var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DailySentence',{attrs:{"inputAudioData":_vm.audioData}},[_c('div',{attrs:{"slot":"line"},slot:"line"},[_c('hr',{staticStyle:{"background-color":"black","height":"1px","border":"none"}})])]),_c('pagination',{staticClass:"m-auto pt-4",attrs:{"current":_vm.pageIndex,"total":_vm.pageCount},on:{"page":_vm.toPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }